var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from 'theme-ui';
import { SimpleTextField } from './SimpleTextField';
export var NumberField = forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'number' : _b, props = __rest(_a, ["type"]);
    return (jsx(SimpleTextField, __assign({ type: type }, props, { sx: { maxWidth: 200 }, ref: ref })));
});
NumberField.displayName = 'NumberField';
//# sourceMappingURL=NumberField.js.map